module.exports = __webpack_public_path__ + "static/media/bold.6eccd20d.svg";